import { fromJS } from "immutable";

const Fields = {

    EXAMPLE: {
        // 'path' = ["demo", "example"] is equivalent to:
        // set: (store, value) => store.setIn(["demo", "example"], value),
        // get: (store) => store.getIn(["demo", "example"])
        path: [ "demo", "example" ]
    },


}

Object.keys(Fields).forEach(fieldName => {
    Fields[fieldName].id = fieldName;

    if (Fields[fieldName].path)
    {
        Fields[fieldName].set = (store, value) => store.setIn(Fields[fieldName].path, fromJS(value))
        Fields[fieldName].get = (store) => store.getIn(Fields[fieldName].path)
    }
})

export default Fields
export { Fields }